<template>
  <div class="order-detail">
    <div class="back">
      <div
        class="button el-icon-arrow-left"
        @click="toBack"
        style="background: #fff; margin-bottom: 10px"
      >
        返回
      </div>
    </div>
    <div class="order-main container">
      <div class="common">订单变更</div>
      <ul>
        <li>
          <div class="title">
            收货信息
            <el-tooltip
              class="item"
              effect="dark"
              v-if="newOrderBaseInfo.orderShipment"
              content="此处信息已发生变更，请仔细核对其中内容是否可确认，操作变更确认即视为认可此处变更。"
              placement="top"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
          <div class="little-title">收货人:</div>
          <div class="cus-info">{{ shipmentInfo.receiveName }}</div>
          <div class="little-title">联系电话:</div>
          <div class="cus-info">{{ shipmentInfo.mobiletelephone }}</div>
          <div class="little-title">收货地址:</div>
          <div class="cus-info">{{ shipmentInfo.receiveAddress }}</div>
        </li>
        <li>
          <div class="title">
            付款信息
            <el-tooltip
              class="item"
              effect="dark"
              v-if="
                (newOrderBaseInfo.hasOwnProperty('isOnLinePay') &&
                  newOrderBaseInfo.isOnLinePay !=
                    oldOrderBaseInfo.isOnLinePay) ||
                (newOrderBaseInfo.hasOwnProperty('otherPay') &&
                  newOrderBaseInfo.otherPay != oldOrderBaseInfo.otherPay) ||
                (newOrderBaseInfo.hasOwnProperty('payCode')  &&
                  newOrderBaseInfo.payCode != oldOrderBaseInfo.payCode)
              "
              content="此处信息已发生变更，请仔细核对其中内容是否可确认，操作变更确认即视为认可此处变更。"
              placement="top"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
          <div class="little-title">付款方式:</div>
          <div class="little-title" style="color: #333">
            {{
              newOrderBaseInfo.isOnLinePay == '1' ? '线上支付' : '线下支付'
            }}-{{ newOrderBaseInfo.payType }}
          </div>

          <div v-if="showInfoflag">
            <div class="little-title">收款银行:</div>
            <eui-tooltip-over class="cus-info"
                              :line="2"
                              :tooltipStyle="{ width: '180px' }"
                              :content="paymentRemark">
              <div>{{paymentRemark }}</div>
            </eui-tooltip-over>
            <div class="cus-info">{{ payerName }}</div>
          </div>

          <div class="little-title">结算方式:</div>
          <div class="cus-info">{{ isDocStr }}</div>
          <div class="little-title">支付金额:</div>
          <div class="cus-info red">
            ¥{{ Number(orderBaseInfo.needPay).toFixed(2) }}
          </div>
          <div
            class="little-title"
            v-if="
              newOrderBaseInfo.otherPay == '1' ||
              oldOrderBaseInfo.otherPay == '1'
            "
          >
            易权通转让:
          </div>
          <div
            class="cus-info red"
            v-if="
              newOrderBaseInfo.otherPay == '1' ||
              oldOrderBaseInfo.otherPay == '1'
            "
          >
            {{
              Number(
                newOrderBaseInfo.otherNeedPay
                  ? newOrderBaseInfo.otherNeedPay
                  : orderBaseInfo.otherNeedPay
              ).toFixed(2)
            }}
            <el-tooltip
              class="item"
              effect="dark"
              content="本订单含一定金额的易权通转让，买家将使用易权通额度完成部分订单额度支付，易权通可在平台中购买任意商品。"
              placement="top"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
        </li>
        <li>
          <div class="title">
            开票信息
            <el-tooltip
              class="item"
              effect="dark"
              v-if="newOrderBaseInfo.orderInvoice"
              content="此处信息已发生变更，请仔细核对其中内容是否可确认，操作变更确认即视为认可此处变更。"
              placement="top"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
          <div class="little-title">开票方式:</div>
          <div class="cus-info">{{ invoiceInfo.invoiceModeCodeStr }}</div>
          <div class="little-title">开票节点:</div>
          <div class="cus-info">
            {{ invoiceInfo.invoiceMode ? invoiceInfo.invoiceModeStr : '' }}
          </div>
          <div class="little-title">发票信息:</div>
          <div class="cus-info">
            <span class="invoice-detail" @click="showInvoiceDetail"
              >发票详情</span
            >
          </div>
          <eui-tooltip-over class="cus-info"
                            :line="2"
                            :tooltipStyle="{ width: '180px' }"
                            :content="invoiceInfo.customer">
            <div>{{ invoiceInfo.customer }}</div>
          </eui-tooltip-over>

          <div class="cus-info">{{ invoiceInfo.identificationNumber }}</div>
          <div class="cus-info">
            {{
              invoiceInfo.invoiceType == '101'
                ? '增值税普通发票'
                : '增值税专用发票'
            }}
          </div>
        </li>
        <li>
          <div class="title">
            配送信息
            <el-tooltip
              class="item"
              effect="dark"
              v-if="
                (newOrderBaseInfo.shipmentType &&
                  newOrderBaseInfo.shipmentType !=
                    oldOrderBaseInfo.shipmentType) ||
                (newOrderBaseInfo.arriveTimeTxt &&
                  newOrderBaseInfo.arriveTimeTxt !=
                    oldOrderBaseInfo.arriveTimeTxt)
              "
              content="此处信息已发生变更，请仔细核对其中内容是否可确认，操作变更确认即视为认可此处变更。"
              placement="top"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
          <div class="little-title">配送方式:</div>
          <div class="cus-info">
            {{ orderBaseInfo.shipmentType == 1 ? '供应商配送' : '采购商自提' }}
          </div>
          <div class="little-title">期望到货日期:</div>
          <div class="cus-info">
            {{
              newOrderBaseInfo.arriveTimeTxt
                ? newOrderBaseInfo.arriveTimeTxt
                : orderBaseInfo.arriveTimeTxt
            }}
          </div>
        </li>
        <li>
          <div class="title">
            其他信息
            <el-tooltip
              class="item"
              effect="dark"
              v-if="newOrderBaseInfo.remark != oldOrderBaseInfo.remark"
              content="此处信息已发生变更，请仔细核对其中内容是否可确认，操作变更确认即视为认可此处变更。"
              placement="top"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
          <div class="little-title">备注信息:</div>
          <div class="cus-info">
            {{
              newOrderBaseInfo.remark
                ? newOrderBaseInfo.remark
                : orderBaseInfo.remark
            }}
          </div>
          <div class="little-title">附件:</div>
          <div class="cus-info break">
            <a
              :href="appendixUrl"
              :download="appendixName"
              target="_blank"
              v-if="appendixUrl"
              >{{ appendixName }}</a
            >
          </div>
        </li>
      </ul>
    </div>

    <div class="container">
      <div class="common" style="margin-bottom: 10px">商品清单</div>
      <TableList
        ref="tableList"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :row-key="rowKey"
      >
        <template v-slot:productName="slot">
          <div class="break" v-if="slot.scope.row.productName.length < 20">
            {{ slot.scope.row.productName }}
          </div>
          <div v-else>
            <eui-tooltip
              class="item"
              effect="dark"
              :content="slot.scope.row.productName"
              placement="top"
            >
              <div class="break">{{ slot.scope.row.productName }}</div>
            </eui-tooltip>
          </div>
        </template>
        <template v-slot:displaySkuOptions="slot">
          <div class="break" v-if="slot.scope.row.displaySkuOptions && slot.scope.row.displaySkuOptions.length < 8">
            {{ slot.scope.row.displaySkuOptions }}
          </div>
          <div v-else>
            <eui-tooltip class="item" effect="dark" :content="slot.scope.row.displaySkuOptions" placement="top" style="height: 44.8px;">
              <div class="break">{{ slot.scope.row.displaySkuOptions }}</div>
            </eui-tooltip>
          </div>
        </template>
        <template v-slot:productSkuCode="slot">
          <div class="break" v-if="slot.scope.row.productSkuCode.length < 10">
            {{ slot.scope.row.productSkuCode }}
          </div>
          <div v-else>
            <eui-tooltip
              class="item"
              effect="dark"
              :content="slot.scope.row.productSkuCode"
              placement="top"
            >
              <div class="break">{{ slot.scope.row.productSkuCode }}</div>
            </eui-tooltip>
          </div>
        </template>

        <template v-slot:price="slot">
          <div class="jc-price-container" v-if="slot.scope.row.price && Number(slot.scope.row.priceType) === 4">
            <img height="20px" width="44px" src="../../../../assets/img/product/jc-icon@2x.png" alt="集采" />
            <div class="jc-price">
              ￥<span>{{ moneyToFixed(slot.scope.row.price) }}</span>
            </div>
          </div>

          <div class="money flex-all-center" v-else>
            <img height="16px" width="45px" class="good-price-box" v-if="Number(slot.scope.row.priceType) === 3"
                 src="../../../../assets/img/product/good-price-icon.png" alt="惠享价"/>
            ￥{{ slot.scope.row.price }}
          </div>

        </template>
        <template v-slot:quantity="slot">
          <div
            :class="{
              'show-back':
                slot.scope.row.oldQuantity &&
                slot.scope.row.oldQuantity != slot.scope.row.quantity,
            }"
            style="display: block"
          >
            <div>{{ slot.scope.row.quantity }}</div>
            <div
              v-if="
                slot.scope.row.oldQuantity &&
                slot.scope.row.oldQuantity != slot.scope.row.quantity
              "
            >
              原数量：{{ slot.scope.row.oldQuantity }}
            </div>
          </div>
        </template>
        <template v-slot:subtotal="slot">
          <div class="money">￥{{ slot.scope.row.subtotal }}</div>
        </template>
        <template v-slot:operate="slot">
          <div class="money">
            {{ slot.scope.row.changeType == 2 ? '已删除此项' : '' }}
          </div>
        </template>
      </TableList>
    </div>

    <div class="back">
      <div class="back">
        <div
          class="button el-icon-arrow-left"
          @click="toBack"
          style="background: #fff; margin-bottom: 10px"
        >
          返回
        </div>
      </div>
      <div class="operate">
        <div class="close refuse" v-debounce="() => changeOperate(2)">拒绝</div>
        <div class="close" v-debounce="() => changeOperate(1)">完成确定</div>
      </div>
    </div>
    <invoice-detail-dialog
      :dialogVisible="invoiceVisible"
      :orderInvoiceVO="invoiceInfo"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import api from '../../api/order';
import TableList from '../../components/common/e-table-list';
import invoiceDetailDialog from './common/invoiceDetailDialog.vue';

export default {
  data() {
    return {
      rowKey: 'userId',
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'center',
          slot: 'productName',
        },
        { label: '商品规格', param: 'displaySkuOptions', align: 'center', width: '80',slot:'displaySkuOptions' },
        {
          label: '商品编码',
          param: 'productSkuCode',
          align: 'center',
          slot: 'productSkuCode',
        },
        {
          label: '商品单价（含税）',
          param: 'price',
          align: 'center',
          width: '150px',
          slot: 'price',
        },
        {
          label: '购买数量',
          param: 'quantity',
          align: 'center',
          slot: 'quantity',
        },
        { label: '已发数量', param: 'sentQuantity', align: 'center' },
        {
          label: '单项运费',
          param: 'shippingCost',
          align: 'center',
          render: (row) => {
            return row.shippingCost ? row.shippingCost : '包邮';
          },
        },
        {
          label: '溢装比例',
          param: 'overShipmentRate',
          align: 'center',
          render: (row) => {
            return row.overShipmentRate
              ? row.overShipmentRate * 100 + '%'
              : '0%';
          },
        },
        {
          label: '计量单位',
          param: 'goodsUnitName',
          align: 'center',
          width: '80',
        },
        {
          label: '小计',
          param: 'subtotal',
          align: 'center',
          width: '80px',
          slot: 'subtotal',
        },
        { label: '操作', param: 'operate', align: 'center', slot: 'operate' },
      ],
      shipmentInfo: {},
      invoiceInfo: {},
      newOrderBaseInfo: {},
      oldOrderBaseInfo: {},
      orderBaseInfo: {},
      paymentRemark:'',
      payerName:'',
      appendixName: '',
      appendixUrl: '',
      isDocStr: '', //结算方式
      invoiceVisible: false,
      showInfoflag:false,
      query: {
        orderId: '',
        purchaseCompanyId: '',
      },
    };
  },
  components: { TableList, invoiceDetailDialog },
  methods: {
    // 保留两位小数
    moneyToFixed(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    },
    //查看发票详情
    showInvoiceDetail() {
      this.invoiceVisible = true;
    },
    closeDialog() {
      this.invoiceVisible = false;
    },

    //判断是否展示收款信息
    showInfo(){
      if(this.payerName){
        //变更了支付方式
        if(this.newOrderBaseInfo.hasOwnProperty('isOnLinePay') &&
                this.newOrderBaseInfo.isOnLinePay !=
                this.oldOrderBaseInfo.isOnLinePay){
          if(Number(this.newOrderBaseInfo.isOnLinePay) === 0){
            this.showInfoflag =  true;
          }else{
            this.showInfoflag = false;
          }
        }else{//没变更支付方式
          if(Number(this.oldOrderBaseInfo.isOnLinePay) === 0){
            this.showInfoflag =true;
          }else{
            this.showInfoflag =false;
          }
        }
      }else{
        this.showInfoflag = false;
      }

    },

    async getOrderDetail() {
      let orderSkuList = [];

      await api
        .orderChangeQuery({ orderId: this.query.orderId })
        .then((res) => {
          //新更改的数据
          this.invoiceInfo = res.data.newChangeDataVO.orderInvoice
            ? res.data.newChangeDataVO.orderInvoice
            : res.data.oldChangeDataVO.orderInvoice;
          this.shipmentInfo = res.data.newChangeDataVO.orderShipment
            ? res.data.newChangeDataVO.orderShipment
            : res.data.oldChangeDataVO.orderShipment;
          orderSkuList = res.data.orderSkuList;
          this.newOrderBaseInfo = res.data.newChangeDataVO;
          this.oldOrderBaseInfo = res.data.oldChangeDataVO;
          this.orderBaseInfo = res.data.oldChangeDataVO;

          this.paymentRemark = res.data.paymentRemark;
          this.payerName = res.data.payerName;

          this.appendixName = res.data.appendixName;
          this.appendixUrl = res.data.appendixUrl;

          // 结算方式处理
          if (Number(res.data.isDoC) === 1) {
            this.isDocStr = '先货后款';
          } else {
            this.isDocStr = '先款后货';
          }

          //开票方式
          switch (res.data.invoiceModeCode) {
            case 1:
              this.invoiceInfo.invoiceModeCodeStr = '一票制';
              break;
            case 2:
              this.invoiceInfo.invoiceModeCodeStr = '两票制';
              break;
            case 3:
              this.invoiceInfo.invoiceModeCodeStr = '一票制、两票制';
              break;
          }

          //开票节点
          if (this.invoiceInfo.invoiceMode === 2) {
            this.$set(this.invoiceInfo, 'invoiceModeStr', '下单后立即开票');
          } else if (this.invoiceInfo.invoiceMode === 3) {
            this.$set(this.invoiceInfo, 'invoiceModeStr', '与其他订单合并开票');
          } else {
            this.$set(this.invoiceInfo, 'invoiceModeStr', '');
          }
        });

      if (orderSkuList.length == 0) {
        let param = {
          orderId: this.query.orderId,
          purchaseCompanyId: this.query.purchaseCompanyId,
          pageNum: 1,
          pageSize: 999,
        };
        let skuListRes = await api.queryOrderSkuList(param);
        if (skuListRes.code == 200) {
          this.tableData = skuListRes.data.records;
        }
      } else {
        //处理为空的情况
        orderSkuList.forEach((item) => {
          if (item.orderId) {
            this.tableData.push(item);
          }
        });
      }


      this.showInfo();
    },
    //变更
    changeOperate(data) {
      api
        .orderChangeAudit({ auditstatus: data, orderId: this.query.orderId })
        .then((res) => {
          if (res.code == '200') {
            this.$message.success(
              data == 1 ? '订单变更成功' : '订单变更拒绝成功'
            );
          }
        });
      setTimeout(() => {
        let times = new Date();
        times = times.getTime();
        this.toBack(times);
      }, 1000);
    },
    toBack(times) {
      if (times !== null) {
        this.$router.push({ path: '/orderManage', query: { t: times } });
      } else {
        this.$router.push({ path: '/orderManage' });
      }
      // this.$router.back();
    },
  },
  mounted() {
    this.query.orderId = this.$route.query.orderId;
    this.query.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.getOrderDetail();
  },
};
</script>

<style scoped lang="scss">
.order-detail {
  .good-price-box{
    margin-right: 4px;
  }
  .jc-price-container {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      position: relative;
      z-index: 1;
    }
    .jc-price {
      height: 18px;
      padding: 0 10px 0 20px;
      margin-left: -20px;
      align-self: flex-end;
      background: #ffeac9;
      line-height: 17px;
      font-size: 14px;
      font-weight: 400;
      border-radius: 4px;
      color: #f0250f;
    }
  }
  .break {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 44.8px;
  }

  .show-back {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    justify-content: center;
    background-color: #f4f7ff;
  }
  .back {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .button {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      cursor: pointer;
      &:hover,
      :active {
        border: 1px solid #2587ff;
        background: #fff;
        color: #2587ff;
      }
    }

    .operate {
      display: flex;

      .close {
        width: 96px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background: #2782ec;
        font-weight: 400;
        color: #fff;
        text-align: center;
        cursor: pointer;
        &:hover {
          background-color: #126edf;
        }
      }

      .refuse {
        margin-right: 20px;
        background: #fff;
        margin-right: 20px;
        color: #333;
        border: 1px solid transparent;
        &:hover,
        :active {
          border: 1px solid #2587ff;
          background: #fff;
          color: #2587ff;
        }
      }
    }
  }
  .money {
    color: red;
  }
  .order-main {
    ul {
      display: flex;
      justify-content: center;
      border: 1px solid #ededed;
      margin-top: 10px;

      li {
        width: 20%;
        border-right: 1px solid #ededed;
        padding-bottom: 20px;
        .title {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          background: #f5f5f5;
          padding-left: 12px;
        }
        .little-title {
          padding: 20px 20px 0 12px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
        .invoice-detail {
          color: #2f80ed;
          cursor: pointer;
          &:hover {
            border-bottom: 1px solid #2f80ed;
          }
        }
        .cus-info {
          margin: 10px 0 0 12px;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
        }

        .red {
          color: red;
        }
      }

      li:first-child {
        padding-left: 0px;
      }

      li:last-child {
        border-right: none;
        word-wrap: break-word;
      }
    }
  }
}
</style>
